import {handleActions} from 'redux-actions';

import {
  FETCH_AUTH_EMAIL,
  FETCH_INITIAL_DATA,
  FETCH_LOGGED_IN_USER,
  FETCH_REMOTE_CONFIG,
  FETCH_TESTING_OPTIONS,
} from '/enum/launchSequence.enum';
import {SIGN_OUT} from '/redux/action/auth.action';
import {
  COMPLETE_STEP,
  CONTINUE_SEQUENCE,
} from '/redux/action/launchSequence.action';
import {withPayload} from '/util/reducer.util';

import authSignOut from './launchSequence/auth/signOut';
import completeStep from './launchSequence/completeStep';
import continueSequence from './launchSequence/continueSequence';

const initialState = {
  completedSteps: {
    [FETCH_LOGGED_IN_USER]: false,
    [FETCH_INITIAL_DATA]: false,
    [FETCH_AUTH_EMAIL]: false,
    [FETCH_TESTING_OPTIONS]: false,
    [FETCH_REMOTE_CONFIG]: false,
  },
};

export default handleActions(
  {
    [CONTINUE_SEQUENCE]: withPayload(continueSequence),
    [COMPLETE_STEP]: withPayload(completeStep),
    [SIGN_OUT]: withPayload(authSignOut),
  },
  initialState,
);
